export enum PagePriv {
  ADD_MODULE = 'addModule',
  MOVE_MODULE = 'moveModule',
}
export type PagePrivileges = {
  [priv in keyof typeof PagePriv]?: boolean;
};
